import { useQuery } from '@tanstack/react-query'

import type { TFields } from '@/src/general/utilities/fetcher/api.types'

import { communityApi } from '../api/communityApi'
import type {
  TGetUserActiveAndVisibleCommunitiesApiOptionalFields,
  TGetUserActiveAndVisibleCommunitiesApiPayload,
} from '../api/getUserActiveAndVisibleCommunities.types'

type TUserActiveAndVisibleCommunitiesParams = {
  userId?: number
}

export const useUserActiveAndVisibleCommunities = <
  Fields extends TFields<TGetUserActiveAndVisibleCommunitiesApiOptionalFields>,
>(
  params: TUserActiveAndVisibleCommunitiesParams &
    Fields &
    Omit<TGetUserActiveAndVisibleCommunitiesApiPayload, 'userId'>,
) =>
  useQuery({
    queryKey: ['get_user_active_and_visible_communities', params],
    queryFn: ({ signal }) =>
      communityApi.getUserActiveAndVisibleCommunities(
        {
          ...params,
          // oxlint-disable-next-line @typescript-eslint/no-non-null-assertion -- the query is only enabled when userId is defined
          userId: params.userId!,
        },
        { signal },
      ),
    retry: 0,
    staleTime: 60 * 1000 * 10, // 10 minutes
    enabled: params.userId !== undefined,
  })
